// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"placeholder--41gnu","react-placeholder-pulse":"react-placeholder-pulse--41gnu","rect":"rect--41gnu","round":"round--41gnu","text":"text--41gnu"};